<template>
    <div>
        <Breadcrumbs main="Services" title="Profile"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
          <div v-if="loading" class="loader-12"></div>
            <div v-else class="user-profile">
              <div class="row">
                <div class="col-md-8 offset-sm-0 offset-md-2">
                <div class="card custom-card">
                    <div class="text-center col-auto">
                        <img class="rounded-circle" v-if="profilePicture" width="100" height="100" :src="`data:image/png;base64,${profilePicture}`">
                        <img class="rounded-circle" v-else width="100" height="100" :src="userImage"> <br>
                    </div>
                    <div class="text-center profile-details">
                        <!-- <h4>{{accountOfficer.name ? accountOfficer.name : 'N/A'}}</h4> -->
                        <h5 class="pt-3">{{ details.customerDetails.fullName }}</h5>
                        <h6 class="mb-2 text-dark">Account Number:</h6>
                        <h6 :class="isCopied ? 'text-success' : 'text-danger'" style="cursor: pointer"
                          v-clipboard:copy="details.accounts[0].accountNumber"
                          v-clipboard:success="onCopy" class="mt-1 mb-3">{{ details.accounts[0].accountNumber }}<i class="ml-1 fa fa-copy"></i></h6>
                        <h6 class="mb-2 text-dark">Referral Code:</h6>
                        <h6 class="mt-1" :class="isCopycode ? 'text-success' : 'text-danger'" style="cursor: pointer"
                          v-clipboard:copy="details.customerDetails.referralCode"
                          v-clipboard:success="onCopyCode">{{ details.customerDetails.referralCode }}<i class="ml-1 fa fa-copy"></i></h6>
                    </div>
                    <div class="card-footer row">
                        <div class="col-lg-6 col-sm-12">
                          <h6 class="text-dark">Phone Number:</h6>
                          <h6><a :href="`tel:${details.customerDetails.phoneNumber1}`">{{details.customerDetails.phoneNumber1 ? details.customerDetails.phoneNumber1 : 'N/A'}}</a></h6>
                          <h6 class="text-dark mt-3">Email:</h6>
                          <h6><a :href="`mailto:${details.customerDetails.email}`">{{details.customerDetails.email}}</a></h6>
                          <h6 class="text-dark mt-3">Home Address:</h6>
                          <h6 class="text-danger">{{details.customerDetails.addressLine1}}</h6>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                          <h6 class="text-dark">Sex:</h6>
                          <h6 class="text-danger">{{details.customerDetails.gender == 1 ? 'Male' : 'Female'}}</h6>
                          <h6 class="text-dark mt-3">Date of Birth:</h6>
                          <h6 class="text-danger">{{ details.customerDetails.dateOfBirth | moment }}</h6>
                        </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from 'moment';
  export default {
    data:() => ({
      loading: false,
      userImage: require('@/assets/TAJimages/user/user.png'),
      isCopied: false,
      isCopycode: false
    }),
    filters: {
      moment: function (date) {
        return moment(date).format('DD-MM-YYYY');
      }
    },
    computed: {
      ...mapState({
        details: state => state.dashboard.dashboardData,
        // eslint-disable-next-line no-confusing-arrow
        accountNumber: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts[0].accountNumber : 'N/A',
        accountOfficer: state => state.authentication.accountofficer,
        profilePicture: state => state.dashboard ? state.dashboard.profilePicture : null,
      }),
      userName() {
        return this.details ? this.details.customerDetails.userName : null;
      },
    },
    mounted() {
      this.loading = true;
      this.$store.dispatch('dashboard/getDashboardData').then(response => {
        if(response.status === 200) {
            this.$store.dispatch('dashboard/getProfilePicture', { username: this.userName }).then(() => {
                this.loading = false
            })
        }
      });
    },
    methods: {
        onCopy() {
            this.isCopied = true;
      },
      onCopyCode () {
        this.isCopycode = true;
      }
    }
  };
</script>
<style scoped>

.user-profile .hovercard .cardheader {
    background: url(../../assets/TAJimages/banner-bg8.jpeg);
    background-size: cover;
    background-position: 10%;
}
.avatar-image {
    margin: 0 auto;
    border-radius: 50%;
    background-color: #fff;
    height: 125px;
    width: 125px;
    margin-top: -50px !important;
    border: 1px solid #ecf3fa
}
</style>